import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// 引入全局iconfont
import '@/assets/iconfont/iconfont.css'
// 引入样式
import '@/styles/index.scss'
import { initPlugin } from './plugins/index'
import '@/styles/md.scss'
// 增加全局路由守卫
import './permission'
import { setupStore } from '@/store'
// 字云
import 'echarts-wordcloud'

const app = createApp(App)
initPlugin(app)
setupStore(app)
app.use(router).mount('#app')
